// extracted by mini-css-extract-plugin
export default {"inputDateStyle":"styles_inputDateStyle__9abkS","notice":"styles_notice__OzuAZ"};